var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible",
    clipPath: "url(#clip0_736_26571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.87842 5.46598L10.1688 7.75637L10.1797 7.6364C10.1797 6.43303 9.20176 5.45508 7.99839 5.45508L7.87842 5.46598Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99806 4.00086C10.0049 4.00086 11.6336 5.6296 11.6336 7.63641C11.6336 8.1054 11.5391 8.55257 11.3755 8.96337L13.5023 11.0902C14.6002 10.174 15.4655 8.98883 15.9999 7.63641C14.7384 4.44442 11.6373 2.18311 7.9981 2.18311C6.98014 2.18311 6.00583 2.36487 5.10059 2.69207L6.67114 4.25897C7.08191 4.09902 7.52908 4.00086 7.99806 4.00086Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.727096 2.01935L2.3849 3.67715L2.71575 4.008C1.51602 4.94597 0.567144 6.19297 0 7.63625C1.25791 10.8282 4.36265 13.0896 7.99819 13.0896C9.12522 13.0896 10.2013 12.8714 11.1866 12.4751L11.4956 12.7842L13.6151 14.9073L14.5422 13.9839L1.65416 1.09229L0.727096 2.01935ZM4.74802 6.03663L5.8714 7.16001C5.83868 7.31635 5.81687 7.47265 5.81687 7.63625C5.81687 8.83963 6.79482 9.81758 7.99819 9.81758C8.16179 9.81758 8.31813 9.79576 8.47083 9.76304L9.59421 10.8864C9.11067 11.1264 8.57263 11.2718 7.99819 11.2718C5.99138 11.2718 4.36265 9.64307 4.36265 7.63625C4.36265 7.06185 4.50808 6.52378 4.74802 6.03663Z",
    fill: "#5D5189"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_26571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvisible);
export default __webpack_public_path__ + "static/media/icon_invisible.b816d6b3a28da4ed9cfb18437f358d7b.svg";
export { ForwardRef as ReactComponent };